// extracted by mini-css-extract-plugin
export default {"AddOutcome":"webpack-pages-DataExtraction-DataExtractionTemplate-components-OutcomesPanel-AddOutcome-AddOutcome-module__AddOutcome"};